import gql from 'graphql-tag'

export const insertUser = user => ({
	mutation: gql`
		mutation ($user: users_insert_input!) {
			insert_users_one(object: $user) {
				id
			}
		}
	`,
	variables: { user }
})
